import Swal from "sweetalert2";

export const ShowMessage = (error, options) => {
  return Swal.fire({
    title: "Анхааруулга",
    html: typeof error === "string" ? error : error.message,
    confirmButtonColor: "rgba(46,48,147,1)",
    confirmButtonText: "OK",
    cancelButtonColor: "rgba(237,28,37,1)",
    cancelButtonText: "Хаах",
    ...options,
  });
};
